import { render, staticRenderFns } from "./TicketTemplate.vue?vue&type=template&id=224aa8d3"
import script from "./TicketTemplate.vue?vue&type=script&lang=js"
export * from "./TicketTemplate.vue?vue&type=script&lang=js"
import style0 from "./TicketTemplate.vue?vue&type=style&index=0&id=224aa8d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports